import './index.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import Topbar from './components/Topbar';
import AdBanner from './components/AdBanner';
import HomePage from './pages/HomePage';
import BrowsePage from './pages/BrowsePage';
import LoginPage from './pages/LoginPage';
import RegisterCustomerPage from './pages/RegisterCustomerPage';
import RegisterProviderPage from './pages/RegisterProviderPage';
import CustomerDashboard from './pages/CustomerDashboard';
import ProviderDashboard from './pages/ProviderDashboard';
import AdminDashboard from './pages/AdminDashboard';
import ReviewPage from './pages/ReviewPage';
import VerifyEmailPage from './pages/VerifyEmailPage';

function PrivateRoute({ children, allowedRole }) {
  const { user, role } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (allowedRole && role !== allowedRole) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <>
      <AdBanner />
      <Topbar />
      <Routes>
        <Route path="/"             element={<HomePage />} />
        <Route path="/browse"       element={<BrowsePage />} />
        <Route path="/login"        element={<LoginPage />} />
        <Route path="/register"     element={<RegisterCustomerPage />} />
        <Route path="/join"         element={<RegisterProviderPage />} />
        <Route path="/review/:id"   element={<PrivateRoute allowedRole="customer"><ReviewPage /></PrivateRoute>} />
        <Route path="/verify-email" element={<VerifyEmailPage />} />
        <Route path="/dashboard"    element={<PrivateRoute allowedRole="customer"><CustomerDashboard /></PrivateRoute>} />
        <Route path="/provider/dashboard" element={<PrivateRoute allowedRole="provider"><ProviderDashboard /></PrivateRoute>} />
        <Route path="/admin"        element={<PrivateRoute allowedRole="admin"><AdminDashboard /></PrivateRoute>} />
        <Route path="*"             element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}
